export const calculateAdditionalData = (data) =>
  data
    .map((row) => ({
      ...row,
      monthsRental: row.cost / row.rental,
      monthsAirbnb: row.cost / row.airbnb,
    }))
    .sort((a, b) => a.monthsAirbnb - b.monthsAirbnb)
    .map((row, index) => ({
      ...row,
      rank: index + 1,
    }));

export const addAdditionalColumns = (columns = [], currencyFormatter) => [
  {
    name: "#",
    accessor: "rank",
  },
  ...columns,
  {
    name: (
      <span>
        Avg. cost of a 3-bed property
        <sup>2</sup>
      </span>
    ),
    accessor: "cost",
    formatter: currencyFormatter,
  },
  {
    name: (
      <span>
        Avg. monthly rental of a 3-bed property
        <sup>3</sup>
      </span>
    ),
    accessor: "rental",
    formatter: currencyFormatter,
  },
  {
    name: "Months until value recuperated via rental",
    accessor: "monthsRental",
    formatter: Math.round,
  },
  {
    name: (
      <span>
        Avg. monthly Airbnb rental 3-bed property
        <sup>4</sup>
      </span>
    ),
    accessor: "airbnb",
    formatter: currencyFormatter,
  },
  {
    name: "Months until value recuperated via Airbnb",
    accessor: "monthsAirbnb",
    formatter: Math.round,
  },
];
